// Бекенд за замовчуванням на порту 8000 (php artisan serve). Перевизначити через REACT_APP_API_URL у .env
const defaultApiUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const dev = {
  API_ENDPOINT_URL: defaultApiUrl,
};

const prod = {
  API_ENDPOINT_URL: defaultApiUrl,
};

const test = {
  API_ENDPOINT_URL: defaultApiUrl,
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
